const LEGACY_NMEA_PREVIEW_LBIDS = new Set([
  "fcf73ee8-979b-11ef-91ac-02c1fe2db5a5",
  "aebb3679-9132-11ef-8b69-02c1fe2db5a5",
]);

const DAGON_NMEA_TIMEZONE_OVERRIDE_LBIDS = new Set([
  "b3f387b4-0b25-11f0-be97-0a900ab7ef27",
  "e969d23c-2682-11f0-b78d-0a900ab7ef27",
]);

export const isLegacyNMEAPreviewLogbook = (
  lbid?: string | null,
): boolean => LEGACY_NMEA_PREVIEW_LBIDS.has(String(lbid));

export const isDagonNMEATimezoneOverrideLogbook = (
  lbid?: string | null,
): boolean => DAGON_NMEA_TIMEZONE_OVERRIDE_LBIDS.has(String(lbid));
